import type { ComponentProps } from "react"

import { cn } from "~/lib/utils"

export const formInputSurface =
	"min-h-10 w-full min-w-0 rounded-lg border border-stroke bg-background px-3 py-2 text-sm text-text-main shadow-xs placeholder:text-text-small focus-visible:outline-1 outline-ring"

function Input({
	className,
	type,
	variant = "default",
	...props
}: ComponentProps<"input"> & {
	variant?: "default" | "title" | "file" | "group" | "form"
}) {
	return (
		<input
			type={type}
			data-slot="input"
			className={cn(
				"flex w-full min-w-0 rounded-md",
				variant === "default" &&
					"h-10 md:h-9 surface-recessed bg-background-tertiary px-3 py-2 sm:py-1 text-base sm:text-sm",
				variant === "form" && formInputSurface,
				variant === "title" &&
					"h-auto bg-transparent px-1 py-2 text-2xl font-semibold tracking-tight text-text-main",
				variant === "file" &&
					"h-auto cursor-pointer bg-transparent px-0 py-1 text-xs file:mr-3 file:rounded-md file:bg-active file:px-3 file:py-1",
				variant === "group" &&
					"h-full flex-1 rounded-none border-0 bg-transparent px-3 py-1 text-sm shadow-none focus-visible:outline-none",
				"placeholder:text-text-small placeholder:font-normal",
				"selection:bg-primary selection:text-primary-foreground",
				"file:inline-flex file:h-7 file:border-0 file:text-foreground file:text-sm file:font-medium [[type=file]]:text-text-small",
				variant !== "file" && "file:mr-4 file:bg-transparent",
				"file:pr-2 file:cursor-pointer",
				variant === "group"
					? "focus-visible:outline-none"
					: "focus-visible:outline-1 outline-ring",
				"aria-invalid:outline-destructive/60 dark:aria-invalid:outline-destructive",
				"aria-invalid:border-destructive/60 dark:aria-invalid:border-destructive",
				"aria-invalid:focus-visible:outline-none",
				"disabled:pointer-events-none disabled:cursor-not-allowed",
				variant === "title" ? "disabled:opacity-100" : "disabled:opacity-50",
				"transition-[color,box-shadow]",
				className
			)}
			{...props}
		/>
	)
}

export { Input }
